import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, ShieldCheckIcon, ThermometerIcon, BrainIcon, ClockIcon } from 'lucide-react';
export function WhatYouGetSection() {
  const items = [{
    icon: <BookOpenIcon className="w-6 h-6 text-gold" data-id="element-147" />,
    title: 'El Manual Principal: Sueño Profundo (Sin Pastillas)',
    desc: 'La guía paso a paso para restaurar tu ciclo natural de descanso.'
  }, {
    icon: <ShieldCheckIcon className="w-6 h-6 text-gold" data-id="element-148" />,
    title: 'El Protocolo de Emergencia',
    desc: 'Qué hacer exactamente si te despiertas a las 3 AM para volver a dormir en 10 minutos.'
  }, {
    icon: <ThermometerIcon className="w-6 h-6 text-gold" data-id="element-149" />,
    title: 'La Guía de la Cámara de Recuperación',
    desc: 'Cómo configurar tu habitación en clima tropical para el éxito biológico.'
  }, {
    icon: <BrainIcon className="w-6 h-6 text-gold" data-id="element-150" />,
    title: 'El Mapa de Descarga Mental',
    desc: 'La técnica de 2 minutos para vaciar las preocupaciones antes de tocar la almohada.'
  }, {
    icon: <ClockIcon className="w-6 h-6 text-gold" data-id="element-151" />,
    title: 'El Diario de Sincronización de 7 Días',
    desc: 'Para rastrear tu progreso y ver los cambios en tiempo real.'
  }];
  return <section className="py-24 px-4 md:px-8 bg-nightBlue" data-id="element-152">
      <div className="max-w-5xl mx-auto" data-id="element-153">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-154">
          <h2 className="font-playfair font-bold text-3xl md:text-4xl text-warmWhite mb-4" data-id="element-155">
            Lo que recibes hoy
          </h2>
          <div className="w-24 h-1 bg-gold mx-auto rounded-full" data-id="element-156" />
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-157">
          {items.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className={`bg-nightBlueLighter p-8 rounded-2xl border border-gold/20 hover:border-gold/50 transition-colors ${index === 0 ? 'md:col-span-2 lg:col-span-3 bg-gradient-to-br from-nightBlueLighter to-nightBlue border-gold/40' : ''}`} data-id="element-158">
              <div className="w-12 h-12 bg-gold/10 rounded-xl flex items-center justify-center mb-6" data-id="element-159">
                {item.icon}
              </div>
              <h3 className="font-montserrat font-semibold text-lg md:text-xl text-warmWhite mb-3" data-id="element-160">
                {item.title}
              </h3>
              <p className="font-lato text-sm md:text-base text-warmWhite/70" data-id="element-161">
                {item.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}